import { useState } from "react";
import LedgerScreen from "./LedgerScreen";
import FieldScreen from "./FieldScreen";
import KeieiScreen from "./KeieiScreen";

export default function FarmScreen({ onGoSubsidy }) {
  const [view, setView] = useState("keiei");

  return (
    <div>
      <div className="type-toggle" style={{ margin: "12px 16px 0" }}>
        <button className={`type-btn ${view === "keiei" ? "active" : ""}`} onClick={() => setView("keiei")}>
          📊 経営
        </button>
        <button className={`type-btn ${view === "ledger" ? "active" : ""}`} onClick={() => setView("ledger")}>
          📒 帳簿
        </button>
        <button className={`type-btn ${view === "field" ? "active" : ""}`} onClick={() => setView("field")}>
          🗺️ 圃場
        </button>
      </div>
      {view === "keiei" && <KeieiScreen onGoSubsidy={onGoSubsidy} />}
      {view === "ledger" && <LedgerScreen />}
      {view === "field" && <FieldScreen />}
    </div>
  );
}
